(function () {
  function equalizeVariantLabels() {
    document.querySelectorAll('.product__varient-quantity').forEach(function (container) {
      var labels = container.querySelectorAll('.form__label, .quantity__label');
      if (labels.length < 2) return;
      labels.forEach(function (l) { l.style.minHeight = ''; });
      var max = 0;
      labels.forEach(function (l) { max = Math.max(max, l.offsetHeight); });
      labels.forEach(function (l) { l.style.minHeight = max + 'px'; });
    });
  }

  document.addEventListener('DOMContentLoaded', equalizeVariantLabels);
  window.addEventListener('resize', equalizeVariantLabels);
})();
